<script setup>
import { FlexRender } from '@tanstack/vue-table';
import SortButton from './SortButton.vue';
import { computed } from 'vue';

const props = defineProps({
  table: {
    type: Object,
    required: true,
  },
  fixed: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'relaxed',
  },
});

const isRelaxed = computed(() => props.type === 'relaxed');

// Misma gramática que la tabla de Contactos, Empresas y Tareas
// (components-next/table/Table.vue): cabecera fija en gris, filas
// separadas con resalte al pasar y las celdas de borde pegadas al margen
// de la tarjeta. Esta usa TanStack por su orden y paginación, así que no
// puede ser la misma pieza, pero sí verse igual.
const EDGE_CLASS = 'ltr:first:pl-5 rtl:first:pr-5 ltr:last:pr-5 rtl:last:pl-5';
</script>

<template>
  <table class="w-full border-collapse" :class="{ 'table-fixed': fixed }">
    <thead class="sticky top-0 z-10 border-b bg-n-alpha-1 border-n-weak">
      <tr v-for="headerGroup in table.getHeaderGroups()" :key="headerGroup.id">
        <th
          v-for="header in headerGroup.headers"
          :key="header.id"
          :style="{
            width: `${header.getSize()}px`,
          }"
          class="px-3 py-2.5 text-xs font-medium tracking-wide text-left uppercase text-n-slate-10"
          :class="EDGE_CLASS"
          @click="header.column.getCanSort() && header.column.toggleSorting()"
        >
          <div
            v-if="!header.isPlaceholder"
            class="flex place-items-center gap-1"
          >
            <FlexRender
              :render="header.column.columnDef.header"
              :props="header.getContext()"
            />
            <SortButton v-if="header.column.getCanSort()" :header="header" />
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="row in table.getRowModel().rows"
        :key="row.id"
        class="transition-colors border-b border-n-weak last:border-b-0 hover:bg-n-alpha-1"
      >
        <td
          v-for="cell in row.getVisibleCells()"
          :key="cell.id"
          class="px-3 align-middle"
          :class="[isRelaxed ? 'py-3' : 'py-2.5', EDGE_CLASS]"
        >
          <FlexRender
            :render="cell.column.columnDef.cell"
            :props="cell.getContext()"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>
